export enum HeaderLayout {
  SmallLogo = "Small Logo",
  LargerLogo = "Larger Logo"
}
